module.exports = __webpack_public_path__ + "assets/media/mac.260e6bad.jpg";